import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { CreatePageList } from "@app/components/Layouts/PageList";
import { Add } from "@app/components/Actions";
import {
  CustomDataGrid,
  Loading,
  MAutocomplete,
  ResponsiveFormContainer,
} from "@app/components";
import { useNavigate } from "react-router-dom";
import { GridRowParams } from "@mui/x-data-grid";
import pathRoutes from "../../routes/pathRoutes";
import { FormProvider, useForm } from "react-hook-form";
import { useMasterTables } from "./utils/useMasterTables";
import { columnsMasterTables } from "./utils/masterTables.columns";
import { configTable } from "./utils/helpers";
import { PermissionComponentGate } from "@app/utils/PermissionComponentGate";
import { RolesTypes } from "../users/utils/helpers";
import usePermission from "@app/context/PermissionContext";

export interface IFormMasterTables {
  type: string;
}

const MasterTablesList = () => {
  const {
    genericTablesList,
    fetchSpecificTable,
    currentTableDataList,
    atributtes,
    loadingSpecificTable,
    resetData,
    currentDataName,
    setCurrentDataName,
  } = useMasterTables();
  const navigate = useNavigate();
  const form = useForm<IFormMasterTables>({
    mode: "all",
    defaultValues: {
      type: currentDataName,
    },
  });
  const { isAdmin, isSuperAdmin } = usePermission();

  const watchType = form.watch("type");

  useEffect(() => {
    const fetchData = async () => {
      if (configTable[watchType]) {
        await configTable[watchType].service();
      } else {
        await fetchSpecificTable(watchType);
      }
    };

    if (watchType) {
      setCurrentDataName(watchType);
      fetchData();
    } else resetData();
  }, [JSON.stringify(watchType)]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleRowDoubleClick = (params: GridRowParams): void => {
    if (isAdmin || isSuperAdmin)
      navigate(
        `${pathRoutes.ADMIN_MASTER_TABLES}/editar/${watchType}/${params.id}`
      );
  };
  return (
    <FormProvider {...form}>
      {loadingSpecificTable && <Loading />}
      <CreatePageList title="Listado de tablas maestras">
        <Box mt={2}>
          <ResponsiveFormContainer columns={4}>
            <MAutocomplete
              name="type"
              options={genericTablesList}
              label="Seleccione una tabla"
            />

            {watchType && (
              <PermissionComponentGate
                permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
              >
                <Add
                  to={`admin/tablas-maestras/nuevo/${watchType}`}
                  title={`Nuevo registro`}
                />
              </PermissionComponentGate>
            )}
          </ResponsiveFormContainer>
        </Box>
        {watchType && (
          <Box
            sx={{ flex: 1, display: "flex", flexDirection: "column", mt: 1 }}
          >
            <CustomDataGrid
              rows={currentTableDataList.length > 0 ? currentTableDataList : []}
              columns={
                configTable[watchType]
                  ? configTable[watchType].columns(atributtes, watchType)
                  : columnsMasterTables(atributtes, watchType) || []
              }
              search={false}
              handleRowDoubleClick={handleRowDoubleClick}
            />
          </Box>
        )}
      </CreatePageList>
    </FormProvider>
  );
};

export default MasterTablesList;
